
import { Avatar } from 'antd';
import { GovardPropertyList } from '../../../shared/ui/GovardPropertyList';
import type { Contact } from '../types';

interface ContactDossierProps {
  contact: Contact;
}

export function ContactDossier({ contact }: ContactDossierProps) {
  return (
    <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Avatar size={64} style={{ backgroundColor: '#f56a00', fontSize: '24px' }}>
          {contact.firstName.charAt(0).toUpperCase()}
        </Avatar>
      </div>

      <GovardPropertyList
        layout="vertical"
        items={[
          { key: 'email', label: 'Email', value: contact.email },
          { key: 'phone', label: 'Phone', value: contact.phone },
          { key: 'company', label: 'Company', value: contact.company },
          { key: 'role', label: 'Role', value: contact.role },
          { key: 'source', label: 'Source', value: contact.source },
        ]}
      />
    </div>
  );
}
